export default class StoreUtil {
  public static moduleNames = {
    meta: 'meta',
    user: 'user',
    plan: 'plan',
    notification: 'notification',
    scan: 'scan',
    coach: 'coach',
    tracker: 'tracker',
  }

  static prefixModuleKeys(module: string, identifier: string) {
    return {
      VALUE: `${identifier}`,
      NAMESPACED: `${module}/${identifier}`,
    }
  }
}
